import React from "react";
import { Box, Typography, Container, Grid, Paper, Button } from "@mui/material";
import Partnership from "../partnership/Partnership";

const pricingPlans = [
    {
        title: "Free",
        price: "$0",
        subtitle: "/mo",
        features: [
            "1 digital clone",
            "Basic customization",
            "Limited integration",
            "Up to 10 messages/day"
        ],
        isPopular: false
    },
    {
        title: "Professional",
        price: "$29",
        subtitle: "/mo",
        features: [
            "1 digital clone",
            "Advanced customization",
            "Integration with Salesforce",
            "1000 messages/day",
            "Drupal plugin",
            "Priority support"
        ],
        isPopular: true
    },
    {
        title: "Enterprise",
        price: "Contact us",
        subtitle: "for pricing",
        features: [
            "Unlimited digital clones",
            "Extended reporting",
            "Affiliation and profit sharing programs",
            "Dedicated fine-tuned AI account",
            "Custom integrations",
            "Dedicated account manager",
            "Dedicated support"
        ],
        isPopular: false
    }
];

export default function Pricing() {
    const handleContactClick = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Box
            id="pricing"
            sx={{
                pt: { xs: 6, md: 10 },
                backgroundImage: 'url(/images/home/pricing_bg.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
                backgroundRepeat: 'no-repeat',
                position: 'relative'
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h3"
                    fontWeight="bold"
                    sx={{
                        textAlign: 'center',
                        mb: { xs: 4, md: 6 },
                        color: '#1e293b',
                        fontSize: { xs: '32px', md: '48px' },
                        lineHeight: 1.2
                    }}
                >
                    Choose a plan that suits You!
                </Typography>

                <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center">
                    {pricingPlans.map((plan, idx) => (
                        <Grid key={plan.title} size={{ xs: 12, md: 4 }}>
                            <Paper
                                elevation={3}
                                sx={{
                                    textAlign: 'left',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '16px',
                                    bgcolor: 'white',
                                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid #f1f5f9',
                                    overflow: 'hidden'
                                }}
                            >
                                <Box sx={{ p: { xs: 3, md: 4 }, flex: 1 }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: '#4671DE',
                                            fontWeight: 600,
                                            mb: 2,
                                            fontSize: { xs: '18px', md: '20px' }
                                        }}
                                    >
                                        {plan.title}
                                    </Typography>

                                    <Box sx={{ mb: 3 }}>
                                        <Typography
                                            variant="h2"
                                            sx={{
                                                color: '#1e293b',
                                                fontWeight: 'bold',
                                                fontSize: { xs: '40px', md: '48px' },
                                                lineHeight: 1,
                                                display: 'inline'
                                            }}
                                        >
                                            {plan.price}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#64748b',
                                                fontSize: { xs: '14px', md: '16px' },
                                                ml: 1,
                                                display: 'inline'
                                            }}
                                        >
                                            {plan.subtitle}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '1px',
                                            bgcolor: '#e2e8f0',
                                            mb: 3
                                        }}
                                    />

                                    <Box sx={{ mb: 3 }}>
                                        {plan.features.map((feature, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    mb: 1.5
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 6,
                                                        height: 6,
                                                        borderRadius: '50%',
                                                        bgcolor: '#4671DE',
                                                        mr: 2,
                                                        flexShrink: 0
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#64748b',
                                                       fontSize: { xs: '14px', md: '15px' }
                                                    }}
                                                >
                                                    {feature}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        py: { xs: 1.5, md: 2 },
                                        borderRadius: 0,
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: { xs: '14px', md: '16px' },
                                        bgcolor: idx === 1 ? '#4671DE' : '#374151',
                                        color: 'white',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            bgcolor: idx === 1 ? '#3b5fcc' : '#2d3748',
                                            boxShadow: 'none'
                                        }
                                    }}
                                    onClick={handleContactClick}
                                >
                                    Contact us
                                </Button>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
     <Partnership/>
            <Box
                sx={{
                    mt: { xs: 6, md: 10 },
                    py: { xs: 8, md: 12 },
                    bgcolor: '#4671DE',
                    color: 'white'
                }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Typography
                                variant="h2"
                                fontWeight="bold"
                                sx={{
                                    fontSize: { xs: '32px', md: '48px' },
                                    lineHeight: 1.2,
                                    textAlign: { xs: 'center', md: 'left' }
                                }}
                            >
                                Inherited from Eternity.ac
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '16px', md: '20px' },
                                    lineHeight: 1.6,
                                    textAlign: { xs: 'center', md: 'left' },
                                    mb: 4
                                }}
                            >
                                We are excited to introduce our advanced AI chatbots for business—built on the proven technology from Eternity.ac. By inheriting and enhancing this cutting-edge AI, we bring you powerful, intelligent chatbots designed to optimize customer interactions, personalize communications with your voice, appearance, character and knowledge, automate workflows, drive sales, improve customer service 24/7.
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Box
                                        sx={{
                                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '12px',
                                            p: 3,
                                            textAlign: 'center',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid rgba(255, 255, 255, 0.2)'
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ color: 'white', mb: 2, fontSize: '18px' }}
                                        >
                                            Real Estate Agency
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px' }}
                                        >
                                            AI agents handle property inquiries, qualify leads, and provide 24/7 customer support with personalized recommendations
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Box
                                        sx={{
                                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '12px',
                                            p: 3,
                                            textAlign: 'center',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid rgba(255, 255, 255, 0.2)'
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ color: 'white', mb: 2, fontSize: '18px' }}
                                        >
                                            Consulting Company
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px' }}
                                        >
                                            Digital consultants provide expert advice, handle client inquiries, and maintain consistent service quality across teams
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Box
                                        sx={{
                                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '12px',
                                            p: 3,
                                            textAlign: 'center',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid rgba(255, 255, 255, 0.2)'
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ color: 'white', mb: 2, fontSize: '18px' }}
                                        >
                                            Psychotherapy Consultancy
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px' }}
                                        >
                                            Custom trained bots provide gestalt therapy sessions, offer initial consultations and mental health support
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
}